import { useEffect, useState } from "react";

// The live feed poll — real state flips only, never filler. Shared by the Desk
// and the In Flight page (4→2 council, 2026-10-22) so both read the same
// events from the same endpoint with the same cadence.
export function useEventsFeed(pollMs = 20000) {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    let stop = false;
    const pull = async () => {
      try {
        const r = await fetch(`/api/ops/events?since=0&limit=50`);
        if (!r.ok) throw new Error(String(r.status));
        const d = await r.json();
        if (!stop && Array.isArray(d.items)) setEvents(d.items);
      } catch {
        /* offline — the feed just stays quiet */
      }
    };
    pull();
    const t = setInterval(pull, pollMs);
    return () => {
      stop = true;
      clearInterval(t);
    };
  }, [pollMs]);

  return events;
}

export default useEventsFeed;
